export default __webpack_public_path__ + "static/media/svg.fd6fd2d4.svg";